// src/utils/settings.js
export const getUserSettings = () => {
  const cached = localStorage.getItem("userSettings");
  if (!cached) return getDefaultSettings();

  try {
    const parsed = JSON.parse(cached);

    // Protezione: se per qualche motivo manca il nuovo flag
    // lo aggiungiamo con valore di default
    return {
      ...getDefaultSettings(),
      ...parsed,
    };
  } catch (e) {
    console.warn("Cache impostazioni corrotta, uso default");
    return getDefaultSettings();
  }
};

const getDefaultSettings = () => ({
  flag_saldoProspettiPaghe: true,
  flag_saldoF24: true,
  flag_accorpato: false,
  software_contabile: "default",
  flag_mostra_codice_ditta: true,
  flag_dettClientiFornitori: false,
  flag_CFPIVA: false,
});
